/*
Copyright (c) 2019 Park Holidays UK Ltd.
*/

// @flow
import { styled } from 'styletron-react';

export const LoadingWrapper = styled(
  'div',
  ({ $color, $theme: { palette } }) => {
    const colors = { ...palette, ...palette.common };

    return {
      boxSizing: 'border-box',
      position: 'absolute',
      top: '0',
      right: '0',
      bottom: '0',
      left: '0',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      backgroundColor: 'transparent', // palette.common.white,
      color: colors[$color !== 'default' ? $color : 'text'],
      borderWidth: '1px',
      borderStyle: 'solid',
      borderColor: colors[$color !== 'default' ? $color : 'text'],
    };
  },
);

export const LoadingSpinner = styled('div', ({ $theme: { spacing } }) => ({
  boxSizing: 'border-box',
  position: 'relative',
  width: '38px',
  height: '38px',
  marginBottom: `${spacing(2)}px`,
  animationDuration: '0.8s',
  animationTimingFunction: 'linear',
  animationIterationCount: 'infinite',
  animationName: {
    to: {
      transform: 'rotate(360deg)',
    },
  },
}));

export const LoadingMessage = styled(
  'div',
  ({ $color, $theme: { typography, palette } }) => {
    const colors = { ...palette, ...palette.common };

    return {
      boxSizing: 'border-box',
      position: 'relative',
      textAlign: 'center',
      color: colors[$color !== 'default' ? $color : 'text'],
      ...typography.h3,
    };
  });
